import FirestoreModel from '../models/firestore-model';
import { collections } from '../models/firestore-model';

class TemplateCategoryService extends FirestoreModel {
  constructor() {
    super(collections.template_categories);
  }
}

export default new TemplateCategoryService();
